module.exports = __webpack_public_path__ + "img/logo_orias.b3774e39.png";